module.exports = __webpack_public_path__ + "img/40.0958517e.jpg";